export default __webpack_public_path__ + "icon76b2424.png";